// Match officials + BokSmart form data (iteration 154)

export const MATCH_OFFICIAL_ROLES = ["referee", "assistant_referee"] as const;
export type MatchOfficialRole = (typeof MATCH_OFFICIAL_ROLES)[number];

export interface MatchOfficialPublic {
  id: string;
  match_id: string;
  role: MatchOfficialRole;
  name: string;
  boksmart_number: string | null;
}

export type MatchOfficialAction = "edit";

export interface MatchOfficialsResponse {
  match_id: string;
  officials: MatchOfficialPublic[];
  _actions: MatchOfficialAction[];
}

// --- BokSmart form data bundle (DRAFT: exact layout pending Gustav's official
// SA Rugby template -- see iteration 154 closeout). Assembled live from the
// lineup (153 backup flags), coach BokSmart numbers (148), and officials. ---

export interface BokSmartPlayerEntry {
  player_id: string;
  player_name: string;
  jersey_number: number;
  backup_hooker: boolean;
  backup_prop: boolean;
}

export interface BokSmartTeamSection {
  team_id: string;
  team_name: string;
  role: string;
  coaches: { name: string; boksmart_number: string | null }[];
  // 157 -- nominated house doctor + practice for the BokSmart medical section
  house_doctor: { name: string | null; practice: string | null; phone: string | null };
  squad: BokSmartPlayerEntry[];
}

export interface BokSmartFormData {
  match_id: string;
  match_name: string;
  starts_at: string;
  age_group: string | null;
  venue: string | null;
  officials: MatchOfficialPublic[];
  teams: BokSmartTeamSection[];
  /** Human-readable notice that this is a draft pending the official template. */
  draft_notice: string;
}
